module.exports = __webpack_public_path__ + "img/shopify_logo.e70bfc76.png";